import React from "react";
import Dropdown from "../Dropdown";
import DropdownTitle from "../Dropdown/Title";
import { TopBarNavItem, TopBarNavItemInline } from "./Nav";

const Title = ({ children, ...props }) => (
	<TopBarNavItemInline Tag={Dropdown.Title} triangle={false} {...props}>
		{children}
	</TopBarNavItemInline>
);

Title.propTypes = {
	...DropdownTitle.Link.propTypes,
};

const Body = ({ ...props }) => <Dropdown.Body {...props} />;

Body.propTypes = {
	...Dropdown.Body.propTypes,
};

const TopBarDropdown = ({ children, isMegaMenu = false }) => (
	<TopBarNavItem isTopBar Tag={Dropdown} dropdown={{ action: "onClick" }} isMegaMenu={isMegaMenu}>
		{children}
	</TopBarNavItem>
);

TopBarDropdown.propTypes = {
	...Dropdown.propTypes,
};

TopBarDropdown.Title = Title;
TopBarDropdown.Body = Body;

export default TopBarDropdown;
